module.exports = __webpack_public_path__ + "img/img15.6d76fedf.jpg";